import LiveDemo from "./Livedemo/liveDemo";
import WatchDemo from "./Watchdemo/watchDemo";

const Demo = () => {
  return (
    <div id="demoComponent">
      <WatchDemo />
      <LiveDemo />
    </div>
  );
};

export default Demo;
